import "core-js/modules/es.array.unshift.js";
import { mapState, mapActions } from "vuex";
import vailcode from "@utils/errcode";
export default {
  name: "usdEvent",
  computed: {
    ...mapState("assets", ["assetsList"])
  },
  data() {
    return {
      balance: {
        usdt: {
          balance: 0
        }
      },
      activitys: [],
      activityList: [],
      activityData: [],
      count: 0,
      isActivityAnim: false,
      mTimer: null,
      aTimer: null
    };
  },
  methods: {
    ...mapActions("assets", ["getAssetsList"]),
    jumpTo() {
      this.WebApp.openLink("https://tonviewer.com/EQAebdctnt2DE6nSS3dkFHmdxHa4ml_Y8U_SShBYdGCYqj_9/jetton/EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs");
    },
    blocksEnter() {
      this.isActivityAnim = true;
    },
    blocksLeave(el, done) {
      this.mTimer = setTimeout(() => {
        clearTimeout(this.mTimer);
        this.isActivityAnim = false;
      }, 3000);
      done();
    },
    async getBalance() {
      await this.getAssetsList();
      this.assetsList.map(item => {
        this.$set(this.balance, item.name, item);
      });
      console.log("balances", this.balance);
      //
    },

    async getWithdrawActivity() {
      const res = await this.$http.post("/user/assets/withdraw/rank", {});
      vailcode(res, () => {
        if (!res.data || !Array.isArray(res.data) || res.data.length === 0) return;
        this.activitys = res.data;
        const firstCount = Math.min(5, this.activitys.length);
        this.activityList = this.activitys.slice(0, firstCount);
        this.activityData = this.activitys.slice(firstCount);
        if (this.activityData.length === 0) {
          this.activityData = this.activitys.slice();
        }
        this._stopActivityLoop = false;
        let pool = this.activityData.slice();
        const getRandomFromPool = () => {
          if (pool.length === 0) {
            pool = this.activityData.slice();
          }
          const i = Math.floor(Math.random() * pool.length);
          return pool.splice(i, 1)[0];
        };
        const wait = ms => new Promise(r => this.aTimer = setTimeout(r, ms));
        (async () => {
          while (!this._stopActivityLoop) {
            const item = getRandomFromPool();
            if (typeof item === "undefined") {
              await wait(2000);
              continue;
            }
            await wait(2000);
            this.activityList.unshift(item);
            await wait(200);
            this.activityList.pop();
          }
        })();
      });
    },
    stopWithdrawActivityLoop() {
      this._stopActivityLoop = true;
      if (this.aTimer) {
        clearTimeout(this.aTimer);
        this.aTimer = null;
      }
    }
  },
  async mounted() {
    await this.getBalance();
    await this.getWithdrawActivity();
  },
  beforeRouteLeave(to, from, next) {
    try {
      clearTimeout(this.mTimer);
      this.stopWithdrawActivityLoop();
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  }
};